import { ColumnName, ColumnNoc, ColumnExpander, ColumnRank, ColumnQualification } from "components/common/TableColumns"
import Label from "components/general/Label"
import { findArray, filterArray, RscFromStore } from 'helpers/utils'
import SportCode from 'components/common/SportCode'
import { getRscObject } from 'helpers/rsc';
import Competitor from "components/presentation/Competitor";


export const filterStages = (data) => {
    let stages = []
        if (data) {
            data?.map(s => {
                s?.extensions?.map(e => {
                    if (e?.ere_code === 'SERIES')
                        stages.push(e)
                })
            })
            return stages
        }
    return ''
}

const getResult = (data) => {
    let stages = []
    if (data) {
        data?.map(s => {
            s?.extensions?.map(e => {
                if (e?.ere_code === 'SERIES_CUM')
                    stages.push(e)
            })
        })
        return stages[stages.length - 1]?.ere_value
    }
    return ''
}

export function ColumnStages({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    remove = false
}) {
    return (
        {
            Header: <Label data='HeaderResults' />,
            remove: remove,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Stages',
            isVisible: false,
            accessor: (props) => {
                let stages = filterStages(filterArray(props.extendedResults, { er_code: ['STAGE'] }))
                if (stages.length > 0) {
                    return stages.map((s, index) => {
                        return <span key={index}>&nbsp;{s.ere_value}</span>
                    })
                }
                return ''
            }
        }
    )
}

export function ColumnTens({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    remove = false
}) {
    return (
        {
            remove: remove,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Tens',
            isVisible: false,
            accessor: (props) => {
                let value = findArray(props.extendedResults, { er_code: ['XS_NUM'] }).er_value
                if (value)
                    return value
                return ''
            }
        }
    )
}

export function ColumnResult({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'HeaderResult',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result',
            remove: remove,
            isVisible: false,
            columnIndex: 20,
            Cell: (props) => {
                let rsc = RscFromStore()
                let discipline = getRscObject(rsc).discipline
                let rowNumberIrm = findArray(props.cell.row.original.extendedResults, { er_code: ['IRM_LAP'] })
                let numberIrm = rowNumberIrm?.er_value || ''
                let resultIrm = (props.cell.row.original.resultIrm)

                let irmObject = {}
                switch (resultIrm) {
                    case 'DNF':
                        irmObject = <><SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} />{numberIrm}</>
                        break;
                    case 'LAP':
                        irmObject = <>{numberIrm}<SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} /></>
                        break;
                    default:
                        irmObject = <SportCode discipline={discipline} entity='@IRM' code={resultIrm} abbr={true} />
                        break;
                }

                return (
                    props.cell.row.original.resultType === 'IRM'
                        ? irmObject
                        : getResult(filterArray(props.cell.row.original.extendedResults, { er_code: ['STAGE'] }))
                            ? getResult(filterArray(props.cell.row.original.extendedResults, { er_code: ['STAGE'] }))
                            : props.cell.row.original.resultData
                )
            },
        }
    )
}

export function ColumnStartOrder(eventUnitCode,{
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'LabelStartOrder',
    accessor = 'startSortOrder',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'StartOrder',
            remove: remove,
            isVisible: false,
            Cell: (props) => {
                const row = props.cell.row.original
                const isTeam = eventUnitCode.includes('T--')

                return (isTeam)
                    ? row?.startOrder
                    : row?.eventUnitEntries?.find(eu => eu?.eue_code === 'START_POS')?.eue_value;
            }

        }
    )
}

function createStages(numSeries) {
    let series = []
    for (let i = 1; i <= numSeries; i++) {
        series.push(
            {
                Header: i,
                className: 'text-end',
                headerClassName: 'text-end w-5',
                disableSortBy: true, //habilita poder ordenar
                id: `Serie ${i}`,
                remove: false,
                columnIndex: i,
                isVisible: false,
                accessor: (props) => {
                    let stages = filterStages(filterArray(props.extendedResults, { er_code: ['STAGE'] }))
                    let value = findArray(stages, { ere_pos: [i.toString()] }).ere_value
                    if (value)
                        return value
                    return ''
                }
            }
        )
    }
    return series
}

export function TableColumnsStartList(numSeries, eventUnitCode) {
    let stages = createStages(numSeries)
    return (
        [
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'StartOrder',
                headerClassName: "text-end w-5 text-nowrap align-middle",
                id: 'HeaderStartOrder',
                isVisible: false,
                columnIndex: 1,
                columns: [
                    ColumnStartOrder(eventUnitCode, { remove: true }),
                ]
            },
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'NOC',
                headerClassName: "text-start w-5 text-nowrap align-middle",
                id: 'HeaderNoc',
                isVisible: false,
                columnIndex: 2,
                columns: [
                    ColumnNoc({ remove: true }),
                ]
            },
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'Name',
                headerClassName: "text-start w-5 text-nowrap align-middle",
                id: 'HeaderName',
                isVisible: false,
                columnIndex: 3,
                columns: [
                    ColumnName({ remove: true }),
                ]
            },
            {
                id: 'HeaderSeries',
                Header: <Label data={'HeaderSeries'} />,
                headerClassName: "text-center w-5",
                isVisible: false,
                columns: [...stages]
            },
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'Result',
                headerClassName: "text-end w-5 text-nowrap align-middle",
                id: 'HeaderResult',
                isVisible: false,
                columns: [
                    ColumnResult({ remove: true, label: "HeaderTotal" }),
                ]
            },
            ColumnTens({}),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsStartListSM(eventUnitCode) {
    return (
        [
            ColumnStartOrder(eventUnitCode, {}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "HeaderTotal" }),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsLiveSM() {
    return (
        [
            ColumnRank({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResult({ label: "HeaderTotal" }),
            ColumnTens({}),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsLive(numSeries) {
    let stages = createStages(numSeries)
    return (
        [
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'Rank',
                headerClassName: "text-end w-5 text-nowrap align-middle",
                id: 'HeaderRank',
                isVisible: false,
                columnIndex: 1,
                columns: [
                    ColumnRank({ remove: true }),
                ]
            },
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'NOC',
                headerClassName: "text-start w-5 text-nowrap align-middle",
                id: 'HeaderNoc',
                isVisible: false,
                columnIndex: 2,
                columns: [
                    ColumnNoc({ remove: true }),
                ]
            },
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'Name',
                headerClassName: "text-start w-5 text-nowrap align-middle",
                id: 'HeaderName',
                isVisible: false,
                columnIndex: 3,
                columns: [
                    ColumnName({ remove: true }),
                ]
            },
            {
                id: 'HeaderSeries',
                Header: <Label data={'HeaderSeries'} />,
                headerClassName: "text-center w-5",
                isVisible: false,
                columns: [...stages]
            },
            {
                Header: "-",
                enableRowSpan: true,
                relatedId: 'Result',
                headerClassName: "text-end w-5 text-nowrap align-middle",
                id: 'HeaderResult',
                isVisible: false,
                columns: [
                    ColumnResult({ remove: true, label: "HeaderTotal" }),
                ]
            },
            ColumnTens({}),
            ColumnQualification({}),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsExpanded(numSeries) {
    let stages = createShots(numSeries)
    return (
        [
            ColumnNameExpand({}),
            ...stages,
            ColumnResultExpand({numSeries}),

        ]
    )
}

export function ColumnNameExpand({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    remove = false
}) {
    return (
        {
            remove: remove,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Tens',
            columnIndex: 1,
            isVisible: false,
            accessor: (props) => {
                return <Competitor {...props.athlete} hidePicture={true} />
            }
        }
    )
}

export function ColumnResultExpand({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    remove = false,
    numSeries,
}) {
    return (
        {
            Header: <Label data='HeaderTotal' />,
            remove: remove,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'ResultExpand',
            columnIndex: 2 + numSeries,
            isVisible: false,
            accessor: (props) => {
                let value = getResult(filterArray(props.extResults, { er_code: ['STAGE'] }))
                return value
            }
        }
    )
}

function createShots(numSeries) {
    let series = []
    for (let i = 1; i <= numSeries; i++) {
        series.push(
            {
                Header: i,
                className: 'text-end',
                headerClassName: 'text-end w-5',
                disableSortBy: true, //habilita poder ordenar
                id: `Shot ${i}`,
                remove: false,
                columnIndex: i + 1,
                isVisible: false,
                accessor: (props) => {
                    let shots = filterArray(props.extResults, { er_code: ['TOTAL'] })
                    let value = findArray(shots, { er_pos: [i.toString()] })?.er_value
                    return value
                }
            }
        )
    }
    return series
}


